export default class TypeUtils {

  static isNumeric = n => !isNaN(parseFloat(n)) && isFinite(n);

  /**
   * Determines if a reference is undefined
   * @param value
   * @returns {boolean}
   */
  static isUndefined = value => typeof value === 'undefined';

  /**
   * Determines if a reference is defined
   * @param value
   * @returns {boolean}
   */
  static isDefined = value => typeof value !== 'undefined';

  /**
   * Determines if a reference is a `String`.
   * @param value
   * @returns {boolean}
   */
  static isString = value => typeof value === 'string';
}
